import { render } from "./EmailSettingsView.vue?vue&type=template&id=d72330fa&scoped=true"
import script from "./EmailSettingsView.vue?vue&type=script&lang=js"
export * from "./EmailSettingsView.vue?vue&type=script&lang=js"

import "./EmailSettingsView.vue?vue&type=style&index=0&id=d72330fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72330fa"]])

export default __exports__